let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6g22N")).then(() => parcelRequire('3Vl5G'));